/**
 * Helpers for the guided boat wizard's routing.
 *
 * react-router 5's `useRouteMatch()` returned the matched *route pattern*, so
 * `url` stayed '/boats/create' no matter which step the location carried and
 * `path.endsWith('/guided')` was never asked to cope with a step suffix.
 * `useLocation()` returns the full path instead — '/boats/create/guided/2' once
 * the user advances — so both checks have to be prefix-based now.
 */

/** True anywhere inside the wizard, including on a numbered step. */
export const isGuidedPath = (pathname: string): boolean => pathname.includes('/guided')

/**
 * The wizard's root path, which <WizardForm> appends step numbers to.
 * Idempotent: passing a path that is already inside the wizard returns the
 * same root rather than nesting another '/guided'.
 */
export const guidedFormRoot = (pathname: string): string => {
  const at = pathname.indexOf('/guided')
  return `${at === -1 ? pathname : pathname.slice(0, at)}/guided`
}

/**
 * The DOM id of the guided wizard's <form>.
 *
 * The wizard's save button lives in the page's <TopToolbar>, i.e. outside the
 * form. react-admin 3 supported that by handing `handleSubmitWithRedirect` up
 * through <FormWithRedirect>'s render prop; v4 removed it, and v5's
 * <SaveButton> calls useFormContext() unconditionally, so it throws outside a
 * form. HTML's own `form` attribute does the job instead: a submit button
 * anywhere on the page can target a form by id.
 */
export const GUIDED_FORM_ID = 'guided-boat-form'
